export function turnAnyInNull(obj) {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      const parsedValue = value === "Any" ? null : value;

      return [key, parsedValue];
    })
  );
}
